<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove invoice {{ipfc.ipfc_nr}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmIpfc">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      ipfc_encrid: null,
      ipfc: {}
    }
  },
  methods: {
    open(ipfc_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/getIpfcTmp.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getIpfcTmp"
          },
          getIpfcTmp: {
            ipfc_encrid: ipfc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.ipfc = res.data.getIpfcTmp;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmIpfc() { 
      this.$axios
        .post("ares/json/ares/task/inpt/ipfc/rmIpfc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmIpfc"
          },
          rmIpfc: {
            ipfc_encrid: this.ipfc.ipfc_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             setTimeout(() => { opener.location.reload(); window.close(); }, 2000);
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmIpfc.text,
              color: res.data.rmIpfc.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

